import React from 'react';
import {
  Paper,
  Typography,
  Box,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

const SelectableCard = ({ 
  icon, 
  label, 
  value, 
  isSelected, 
  onSelect, 
  disabled = false,
  fullWidth = false 
}) => {
  const selectionColor = 'text.primary';

  return (
    <Paper
      elevation={0}
      onClick={() => !disabled && onSelect(value)}
      sx={{
        p: '16px',
        textAlign: 'left',
        cursor: disabled ? 'not-allowed' : 'pointer',
        borderRadius: '12px',
        border: '1.5px solid',
        borderColor: isSelected ? selectionColor : 'grey.300',
        transition: 'border-color 0.2s ease-in-out',
        position: 'relative',
        opacity: disabled ? 0.6 : 1,
        width: fullWidth ? '100%' : 'auto',
        minHeight: '90px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        backgroundColor: 'background.paper',
        boxShadow: 'none',
        '&:hover': {
          borderColor: !disabled ? selectionColor : 'grey.300',
          boxShadow: 'none',
        },
      }}
    >
      {isSelected && (
        <CheckIcon 
          sx={{ 
            position: 'absolute', 
            top: '12px',
            right: '12px',
            color: selectionColor, 
            fontSize: '22px' 
          }} 
        />
      )}
      {icon && (
        <Box sx={{ 
          fontSize: '1.75rem',
          mb: 0.75,
          color: isSelected ? selectionColor : 'text.secondary', 
          lineHeight: 1,
          display: 'flex',
          alignItems: 'center',
        }}>
          {icon}
        </Box>
      )}
      <Typography 
        variant="body1"
        sx={{ 
          fontWeight: isSelected ? 500 : 400,
          color: isSelected ? selectionColor : 'text.primary', 
          lineHeight: 1.4,
          textAlign: 'left',
        }}
      >
        {label}
      </Typography>
    </Paper>
  );
};

export default SelectableCard; 